import { createTheme, ThemeProvider } from "@material-ui/core";
import React, { useMemo, useState} from "react";
import {
    ConnectionProvider,
    WalletProvider,
} from "@solana/wallet-adapter-react";
import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
    getPhantomWallet,  
    getSolflareWallet,
    getSolflareWebWallet,
    getSolletWallet,
    getSolletExtensionWallet,
} from "@solana/wallet-adapter-wallets";

import {
    WalletModalProvider
} from '@solana/wallet-adapter-react-ui';

import "./App.css";
import Home from "./Home";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import { AnimatePresence } from "framer-motion";

require('@solana/wallet-adapter-react-ui/styles.css');


const candyMachineId = new anchor.web3.PublicKey(
  process.env.REACT_APP_CANDY_MACHINE_ID!
);

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const theme = createTheme({
    palette: {
        type: 'dark',
    },
    overrides: {
        MuiButtonBase: {
            root: {
                justifyContent: 'flex-start',
            },
        },
        MuiButton: {
            root: {
                textTransform: undefined,
                padding: '12px 16px',
            },
            startIcon: {
                marginRight: 8,
            },
            endIcon: {
                marginLeft: 8,
            },
        },
    },
});

const App = () => {
    // Custom RPC endpoint.
  const endpoint = useMemo(() => clusterApiUrl(network), []);

    // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
    // Only the wallets you configure here will be compiled into your application, and only the dependencies
    // of wallets that your users connect to will be loaded.
    const wallets = useMemo(
        () => [
            getPhantomWallet(),           
            getSolflareWallet(),
            getSolletWallet({ network }),
            getSolflareWebWallet(),            
            getSolletExtensionWallet({ network }),
        ],
        []
    );
    const [didVideoPlay, setDidVideoPlay] = useState(false);
    const nodeRef = React.useRef(null)
    return (
      <SwitchTransition>
        <CSSTransition
          key={didVideoPlay ? "true" : "false"}
          timeout={500}
          classNames="fade"
          nodeRef={nodeRef}         
        >
          {didVideoPlay ? (
            <AnimatePresence >  
              <ThemeProvider theme={theme}>
                <ConnectionProvider endpoint={endpoint}>
                  <WalletProvider wallets={wallets} autoConnect={true}>
                    <WalletModalProvider logo="/logo-dark.png" featuredWallets={3} >
                      <Home
                        candyMachineId={candyMachineId}
                        connection={connection}
                        txTimeout={txTimeout}
                        rpcHost={rpcHost}
                        network={network}
                      />
                    </WalletModalProvider>
                  </WalletProvider>
                </ConnectionProvider>
              </ThemeProvider>  
            </AnimatePresence>
          ) : (
            <LoadingScreen
              didVideoPlay={didVideoPlay}
              setDidVideoPlay={setDidVideoPlay}
            />
          )}
        </CSSTransition>
      </SwitchTransition>
    );
  };
  
  export default App;
